<template>
  <div style="display: grid; grid-template-rows: auto auto 1fr; grid-gap: 0.5vw; font-family: 'Nunito';">
    <span style="font-size: 1.1vw; font-weight: bold; font-family: 'Baloo 2'">Partage Learn and Watch avec {{currentShow.english_title}}!</span>
    <div class="plainStandardTheme flexwrap centercenter" style="padding: 20px;">
      <div class="lightTheme shareimg centercenter mediumRoundAngles mediumShadow" style="height:300px; width: 500px;"
           :style="{backgroundImage: 'url(' + 'https://learnandwatch.s3.eu-west-3.amazonaws.com/blur/' +
               currentShow.background_path + ')'}">
        <div class="flexwrap textShadow" style="font-size: 200%; font-weight: bold; color: var(--lightColor); flex-direction:column">
          <span style="font-size: 1.15em;">10 nouveaux mots d'anglais</span> découverts avec
          <span class=" plainTheme flexwrap centercenter textShadow bigPaddingRound bigShadow" style="font-size: 1.2em; width: fit-content; font-weight: bold; color: var(--lightColor);">{{currentShow.french_title.decodeEscapeSequence().split('(')[0].trim() }}</span>
        </div>



        <div id="shareLogo" :style="{ backgroundImage: 'url(' + require('../assets/logo.png')+ ')' }"></div>


      </div>
    </div>

    <div id="shareBox">
        <ShareNetwork
            network="facebook"
            :url="url"
            :title="title"
            :quote="title"
            @click="shareTag"
        >
          <h2 id="shareFacebook" class="shareItem clickable paddingRound mediumRoundAngles mediumShadow" title="Partager sur Facebook">
            <i class="fab fa-facebook-square"></i>
            <div style="font-size: 0.9vw">Facebook</div>
          </h2>
        </ShareNetwork>
      <!--
        <ShareNetwork
            network="twitter"
            :url="url"
            :title="title"
            @click="shareTag"

        >
          <h2 id="shareTwitter" class="shareItem clickable plainStandardTheme paddingRound mediumRoundAngles mediumShadow" title="Partager sur Twitter">
            <i class="fab fa-twitter-square"></i>
            <div style="font-size: 0.9vw">Twitter</div>
          </h2>
        </ShareNetwork>
        <ShareNetwork
            network="Email"
            :url="url"
            :title="title"
            :description="title"
            @click="shareTag"
        >
          <h2 id="shareMail"  class="shareItem clickable plainStandardTheme paddingRound mediumRoundAngles mediumShadow" title="Partager par mail">
            <i class="fas fa-envelope"></i>
            <div style="font-size: 0.9vw">Mail</div>
          </h2>
        </ShareNetwork>-->

    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import VueSocialSharing from 'vue-social-sharing'
import {mapGetters} from 'vuex'
Vue.use(VueSocialSharing);

export default {
  name: "share",
  computed: {
    ...mapGetters('global', [
        'isMobile', 'routeName'
    ]),
    ...mapGetters('show', [
      'currentShow',
      'currentSeason',
      'currentEpisodeData'
    ]),

    url() {
      return location.host + location.pathname
    },
    title(){
      return "Regardez le vocabulaire que j'apprends avec la saison" + this.currentSeason.num +  " de " + this.currentShow.english_title + " sur Learn and Watch! :)"
    }
  },
  methods: {
    shareTag: function (){
      gtag('event', 'Shared', {
        'event_category': 'Share'
      })
    }
  }
}
</script>

<style scoped>
  #shareBox{
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 0.5vw;
    width: 7vw;
  }
  .shareItem{
    width: 100%;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    color: #eeeeee;
    font-weight: bold;
    font-size: 1vw;
    grid-column-gap: 0.3vw;
  }

  #shareFacebook{
    background-color: #3b5998;
  }

  #shareTwitter{
    background-color: #52a8e7;
  }

  #shareMail{
    background-color: #d44337;
  }
  #shareLogo{
    position: absolute;
    right:10px;
    bottom:10px;
    height: 60px;
    width: 120px;
    background-size: contain;
    background-repeat: no-repeat;
    align-self: flex-end;

  }
  .shareimg{
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right center;
    display: grid;
    grid-template-rows: 1fr 30px;
    text-align: center;
    padding: 30px;
  }

</style>